import React, { Component } from 'react'
import JqxGrid from '../../widgets/jqwidgets-react/react_jqxgrid';
import JqxMenu from '../../widgets/jqwidgets-react/react_jqxmenu';
import io from '../../utils/socket-client';
import {createGridResizer} from '../../utils/Sizer';
import locale from '../../GridLocale';
import {generateRandomString} from '../../utils/utils';

export default class UserGrid extends Component {

    constructor(props){
        super(props);
        this.source = {
            localdata: this.props.users,
            datatype: 'array',
            datafields: [
                { name: 'login', type: 'string' },
                { name: 'userName', type: 'string' },
                { name: 'password', type: 'string' },
                { name: 'localeType', type: 'string'},
                { name: 'groupAccess', type: 'array'}
            ],
        };
        this.dataAdapter = new window.$.jqx.dataAdapter(this.source);
        this.gridWidth = 820;
        this.state = {isContextMenuUser: false};
        //Свойство isFirstDeletedRow это костыль для корректного удаления строк. Дело в том, что после 1-2 удаленных строк, количество строк в source.localdata
        //не обновляется автоматически, из-за чего вновь созданная ссылка с индексом строки указывает на уже удаленные данные.
        //Это свойство инициализируется в true, а после первого удаления ставится в false, и при удалении проверяется, если свойство равно false, данные удаляются вручную.
        // this.isFirstDeletedRow = true;
    }

    componentWillReceiveProps(nextProps){
        this.source.localdata = nextProps.users;
    }

    shouldComponentUpdate(nextProps, nextState){
        return false;
    }

    componentDidMount(){
        this.refs.grid.localizestrings(locale);
        createGridResizer(this, this.gridWidth);
        // window.$(window).resize(this.resizer);
        this.refs.grid.on('cellselect', (event) => {
            this.currentSelectedRow = event.args.rowindex;
        });
        this.refs.grid.on('cellunselect', () => {
            this.currentSelectedRow = null;
        });
        this.refs.grid.on('contextmenu', () => {
            return false;
        });
        this.refs.grid.on('rowclick', (event) => {
            this.currentSelectedRow = event.args.rowindex;
            if (event.args.rightclick) {
                this.refs.grid.selectrow(event.args.rowindex);
                let scrollTop = window.$(window).scrollTop();
                let scrollLeft = window.$(window).scrollLeft();
                let xCoords = (window.$(window).innerWidth() - parseInt(event.args.originalEvent.clientX, 10) > 130)
                    ? parseInt(event.args.originalEvent.clientX, 10) + 5 + scrollLeft
                    : parseInt(event.args.originalEvent.clientX, 10) - 130 + scrollLeft;
                let yCoords;
                let source = [
                    {label: 'Добавить'},
                    {label: 'Удалить'},
                    {label: 'Сменить пароль'}
                ];
                if(this.source.localdata[event.args.rowindex].type === 'promoter'){
                    window.$('#contextMenuRef').css({ height: '116px' });
                    yCoords = (window.$(window).innerHeight() - parseInt(event.args.originalEvent.clientY, 10) > 116)
                    ? parseInt(event.args.originalEvent.clientY, 10) + 5 + scrollTop
                    : parseInt(event.args.originalEvent.clientY, 10) - 111 + scrollTop;
                } else {
                    source.push({label: 'Сгенерировать ссылку'});
                    source.push({label: 'Назначить группы'});
                    window.$('#contextMenuRef').css({ height: '174px' });
                    yCoords = (window.$(window).innerHeight() - parseInt(event.args.originalEvent.clientY, 10) > 174)
                        ? parseInt(event.args.originalEvent.clientY, 10) + 5 + scrollTop
                        : parseInt(event.args.originalEvent.clientY, 10) - 169 + scrollTop;
                }
                source.push({label: 'Закрыть'});
                this.refs.contextMenuRef.source(source);
                this.refs.contextMenuRef.open(xCoords, yCoords);
                return false;
            }
        });

        this.refs.contextMenuRef.on('itemclick', (event) => {
            let args = event.args;
            let row = this.currentSelectedRow;
            this.refs.contextMenuRef.close();
            switch(window.$.trim(window.$(args).text())){
                case 'Добавить':
                    this.props.openNewUserModal();
                    break;
                case 'Удалить':
                    setTimeout(() => {
                        if(window.confirm('Удалить?')) this.removeUser(row);
                    }, 150);
                    break;
                case 'Сгенерировать ссылку':
                    this.createLink();
                    break;
                case 'Сменить пароль':
                    this.changePassword();
                    break;
                case 'Назначить группы':
                    this.props.openChangeGroupAccess(this.source.localdata[this.currentSelectedRow], this.currentSelectedRow);
                    break;
                default:
                    break;
            }
        });
    }

    removeUser(row){
        // console.log('source.length before remove: ', this.source.localdata.length);
        const {login, type} = this.source.localdata[row];
        const rowid = this.refs.grid.getrowid(row);
        io.sendChange({
            uri:io.USER_URI,
            operation: io.OPERATION_REMOVE,
            id: {login: login},
            success: () => {
                this.refs.grid.deleterow(rowid);
                this.props.removeUser(login, type);
                // if(!this.isFirstDeletedRow){
                //     this.source.localdata.splice(row, 1);
                // }
                // this.isFirstDeletedRow = false;
                // console.log('--- remove user ---  LOGIN: ' + login);
                // console.log('source.length after remove: ', this.source.localdata.length);
            }
        });
    }

    changePassword(){
        let row = this.currentSelectedRow;
        let autoPassword = generateRandomString(6, false);
        let result = prompt('Введите новый пароль', autoPassword);
        if(result){
            io.sendChange({
                uri: io.CHANGE_PASSWORD_URI,
                id: {login: this.source.localdata[row].login},
                data: {password: result},
                operation: io.OPERATION_MODIFY,
                fail: () => this.props.setError('Не удалось изменить пароль')
            })
        }
    }

    createLink(){
        let row = this.currentSelectedRow;
        let token = generateRandomString(16, true);
        io.sendChange({
            uri: io.CHANGE_TOKEN_URI,
            operation: io.OPERATION_MODIFY,
            data: {token},
            id: {login: this.source.localdata[row].login},
            fail: () => this.props.setError('Не удалось сгенерировать ссылку, попробуйте снова!'),
            success: () => {
                this.props.openNewLinkModal(token);
            }
        });
    }

    render() {
        let self = this;
        let columns = [
            { text: 'Логин', datafield: 'login', width: 200, editable: false},
            { text: 'Имя', datafield: 'userName', width: 200,
                cellvaluechanging: function(row, column, columntype, oldvalue, newvalue) {
                    if(oldvalue === newvalue) return;
                    const {login, type} = self.source.localdata[row];
                    let rowid = self.refs.grid.getrowid(row);
                    let updatedRowData = self.source.localdata[row];
                    io.sendChange({
                        uri:io.USER_URI,
                        operation: io.OPERATION_MODIFY,
                        data: {userName: newvalue},
                        id: {login: login},
                        fail: () => {
                            updatedRowData.userName = oldvalue;
                            self.refs.grid.updaterow(rowid, updatedRowData);
                            this.props.setError('Не удалось изменить имя!');
                        },
                        success: () => {
                            self.props.changeUserName(login, newvalue, type);
                        }
                    });
                }},
            { text: 'Группы', datafield: 'groupAccess', width: 200, editable: false
            },
            { text: 'Тип', datafield: 'localeType', width: 200, editable: false }
        ];
        return (
                <div ref={'container'} style={{display: 'flex', height: '100%', justifyContent: 'center', marginTop: 5, zIndex: -1, overflow: 'hidden'}}>
                    <JqxGrid
                        ref={'grid'}
                        width={this.gridWidth}
                        height={window.$(window).innerHeight() - 45}
                        editable={true}
                        filterable={true}
                        showfilterrow={true}
                        enabletooltips={true}
                        sortable={true}
                        source={this.dataAdapter}
                        columns={columns}
                        selectionmode={'singlecell'}/>
                    <JqxMenu ref='contextMenuRef' id="contextMenuRef"
                             width={130} mode={'popup'} autoOpenPopup={false}>
                    </JqxMenu>
                </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/grids/UserGrid.js